<template>
  <div class="mainDiv">
    <el-row>
      <el-form ref="queryCondition" :model="queryCondition" label-position="right" label-width="100px">
        <el-col :span="10">
          <el-form-item label="菜单名称">
            <el-input size="mini" v-model="queryCondition.menuName" clearable placeholder="请输入内容"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item>
            <el-button type="primary" size="mini" @click="query()" icon="el-icon-search">查询</el-button>
            <el-button type="primary" plain size="mini" @click="reset" icon="el-icon-refresh">重置</el-button>
          </el-form-item>
        </el-col>
      </el-form>
    </el-row>

    <el-row class="mb">
      <el-table :data="tableData" row-key="id" size="mini"  default-expand-all
                :tree-props="{children: 'children', hasChildren: 'hasChildren'}" header-row-class-name="tableHeader">
        <el-table-column prop="name" label="菜单名称"  width></el-table-column>
        <el-table-column prop="url" label="路径"  width></el-table-column>
        <el-table-column prop="isShow" label="是否显示"  width :formatter="formatIsShow"></el-table-column>
        <el-table-column prop="icon" label="图标"  width></el-table-column>
        <el-table-column prop="level" label="级别"  width></el-table-column>
        <el-table-column prop="sort" label="顺序"  width></el-table-column>
        <el-table-column fixed="right" align="center" label="操作" width="400">
          <template slot-scope="scope">
            <el-tooltip content="增加子菜单" placement="top" effect="light">
              <el-button @click="append(scope.row)" icon="el-icon-plus" size="small"></el-button>
            </el-tooltip>
            <el-tooltip content="编辑" placement="top" effect="light">
              <el-button @click="edit(scope.row)" icon="el-icon-edit" size="small"></el-button>
            </el-tooltip>
            <el-tooltip content="删除" v-if="false" placement="top" effect="light">
              <el-button type="danger" plain @click="remove(scope.row)" icon="el-icon-delete" size="small"></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </el-row>

    <el-dialog title="菜单管理" :visible="visible" :fullscreen="false" @close="closeDialog" width="30%"
               :close-on-click-modal="false">
      <el-form :model="menuForm" status-icon :rules="rules" ref="menuForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="菜单名称" prop="name">
          <el-input v-model="menuForm.name" :maxlength="25" placeholder="请输入内容"></el-input>
        </el-form-item>
        <el-form-item label="菜单排序" prop="sort">
          <el-input v-model="menuForm.sort" placeholder="请输入数字"></el-input>
        </el-form-item>
        <el-form-item label="菜单路径" prop="url">
          <el-input v-model="menuForm.url" placeholder="请输入内容"></el-input>
        </el-form-item>
        <el-form-item label="是否显示" prop="isShow">
          <el-select size="mini" v-model="menuForm.isShow"  placeholder="请选择" class="dialogDataWidth"
                     style="width: 60%;">
            <el-option v-for="item in isShowType" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
          <!--<el-input v-model.number="menuForm.isShow" placeholder="请输入数字"></el-input>-->
        </el-form-item>
        <el-form-item label="菜单图标" prop="icon">
          <el-input v-model="menuForm.icon" placeholder="请输入内容"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="save">保存</el-button>
          <el-button @click="closeDialog">关闭</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
  export default {
    name: "menuList",
    components: {},
    created: function () {
      this.query();
      this.getDetpTree();
    },
    data() {
     var checkNumber = (rule, value, callback) => {
         var numReg = /^[0-9]+$/
         var numRe = new RegExp(numReg)
         if (value===''||value==="") {
           return callback(new Error('不能为空'));
         }
         if (!numRe.test(value)) {
           callback(new Error('请输入数字值'));
         }else {
           callback();
         }
      };
      return {
        isShowType:[
          {id:1,name:'是'},
          {id:2,name:'否'}
        ],
        msg: "this is department",
        tableData: [],
        queryCondition: {
          menuName: ""
        },
        pagedata: {
          content: [],
          totalElements: 0,
          totalPages: 1,
          size: 100,
          number: 1
        },
        deptData: [],
        visible: false,
        menuForm: {
          id: 0,
          parentId: 1,
          name: "",
          level: 2,
          sort: "",
          url:"",
          isShow:1,
          icon:""
        },

        rules: {
          sort: [
            {
              validator: checkNumber,
              required: true,
               trigger: "blur"
            }
          ],
          name: [
            {
              required: true,
              message: "请填写菜单名称",
              trigger: "blur"
            }
          ],
          level:[ {
            validator: checkNumber,
            required: true,
            trigger: "blur"
          }],
          url:[ {
            required: true,
            message: "请填写路径",
            trigger: "blur"
          }]
          ,
          isShow:[ {
            required: true,
            message: "请填写是否显示",
            trigger: "blur"
          }]
        }
      };
    },
    methods: {
      formatIsShow(row, column) {
        if (row.isShow == 1) {
          return '是';
        }
        if (row.isShow == 2) {
          return '否';
        }
      },
      save: function () {
        this.$refs["menuForm"].validate(valid => {
          if (valid) {
            var _self = this;
            this.$axios.post("/menu/save", this.menuForm).then(response => {
              _self.$message({
                message: "保存成功",
                type: "success"
              });
              _self.$refs["menuForm"].resetFields();
              _self.getDetpTree();
              this.visible = false;
            });
          }
        });
      },
      closeDialog: function () {
        this.visible = false;
        this.menuForm = {
          id: 0,
          parentId: 1,
          name: "",
          level: 2,
          sort: "",
          url:"",
          isShow:1,
          icon:""
        },
        this.$refs["menuForm"].resetFields();
      },
      append(data) {
        this.menuForm.parentId = data.id;
        this.menuForm.level = data.level + 1;
        this.visible = true;
      },
      edit(data) {
        this.menuForm.url = data.url;
        this.menuForm.icon = data.icon;
        this.menuForm.isShow = data.isShow
        this.menuForm.name = data.name;
        this.menuForm.sort = data.sort;
        this.menuForm.id = data.id;
        this.menuForm.parentId = data.parentId;
        this.menuForm.level = data.level;
        this.visible = true;
      },
      remove(data) {
        if (data.parentid == 0) {
          this.$message({
            message: "根节点不允许删除",
            type: "warning"
          });
          return false;
        }
        this.$confirm("是否删除此菜单?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          var _self = this;
          this.$axios.get("/menu/delete?id=" + data.id).then(res => {
            if (res.code == "0000") {
              _self.$message({
                type: "success",
                message: res.message
              });
              _self.getDetpTree();
            } else {
              _self.$message({
                type: "warning",
                message: res.message
              });
            }
          });
        });
      },

      getDetpTree: function () {
        let that = this;
        this.$axios.get("/menu/getMenuList").then(response => {
          if (
            response.data !== null &&
            response.data !== "" &&
            response.data !== undefined
          ) {
            that.tableData = response.data;
          }
        });
      },
      // 查询按钮
      query: function () {
        var url = "/menu/menuPage";
        if (this.queryCondition.menuName == "") {
          this.getDetpTree();
          return;
        }
        url += "?menuName=" + this.queryCondition.menuName;
        url +=
          "&pageNumber=" +
          this.pagedata.number +
          "&pageSize=" +
          this.pagedata.size;
        let that = this;
        this.$axios.get(url).then(response => {
          if (
            response.data !== null &&
            response.data !== "" &&
            response.data !== undefined
          ) {
            that.tableData = response.data.content;
          }
        });
      },
      reset: function () {
        this.queryCondition.menuName = '';
        this.$refs.queryCondition.resetFields();
        this.query();
      }
    }
  };
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/menu/list.vue